// AUTO-GENERATED
//
// This code was automatically generated.
// It should not be modified by hand. Make changes to template files located at
// `generated/frontend-events`, then re-generate this file with `tracking-gen`.

type ResultType = [string, object]

/**
 * Loading Time
 * App Ready for User Interaction
 */
export type TrackLoadingTimeAppReadyForUserInteractionType = {
  deltaSeconds: string
  screen?: string
}

export const trackLoadingTimeAppReadyForUserInteractionPayload = ({
  deltaSeconds,
  screen,
}: TrackLoadingTimeAppReadyForUserInteractionType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Loading Time',
    event_description: 'App Ready for User Interaction',
    platforms: 'web',
    object: 'Time',
    action: 'Analysis',
    object_name: 'loadingTimeAppReady',
    delta_seconds: deltaSeconds,
    screen,
  }

  if (!screen) {
    delete payload.screen
  }

  return ['Time Analysis', payload]
}

/**
 * Two Factor Auth
 * Phone Number Disabled Modal Viewed
 */
export type TrackTwoFactorAuthPhoneNumberDisabledModalViewedType = {
  screen: string
}

export const trackTwoFactorAuthPhoneNumberDisabledModalViewedPayload = ({
  screen,
}: TrackTwoFactorAuthPhoneNumberDisabledModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Phone Number Disabled Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'textVerificationDisabled',
    screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Two Factor Auth
 * Phone Number Disabled Modal Help Tapped
 */
export type TrackTwoFactorAuthPhoneNumberDisabledModalHelpTappedType = {
  screen: string
}

export const trackTwoFactorAuthPhoneNumberDisabledModalHelpTappedPayload = ({
  screen,
}: TrackTwoFactorAuthPhoneNumberDisabledModalHelpTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Phone Number Disabled Modal Help Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'textVerificationDisabledHelp',
    screen,
  }

  return ['Button Tapped', payload]
}

/**
 * Two Factor Auth
 * Phone Number Disabled Modal Try Again Tapped
 */
export type TrackTwoFactorAuthPhoneNumberDisabledModalTryAgainTappedType = {
  screen: string
}

export const trackTwoFactorAuthPhoneNumberDisabledModalTryAgainTappedPayload =
  ({
    screen,
  }: TrackTwoFactorAuthPhoneNumberDisabledModalTryAgainTappedType): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Two Factor Auth',
      event_description: 'Phone Number Disabled Modal Try Again Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'textVerificationDisabledTryAgain',
      screen,
    }

    return ['Button Tapped', payload]
  }

/**
 * OAuth Flow
 * OAuth Event Occurred
 */
export enum OAuthFlowOAuthEventOccurredType {
  'Login_page_landed' = 'login_page_landed',
  'Login_button_clicked' = 'login_button_clicked',
  'Mfa_page_landed' = 'mfa_page_landed',
  'Mfa_button_clicked' = 'mfa_button_clicked',
  'Authorization_page_landed' = 'authorization_page_landed',
  'Authorization_button_clicked' = 'authorization_button_clicked',
}

export type TrackOAuthFlowOAuthEventOccurredType = {
  screen: string
  type: OAuthFlowOAuthEventOccurredType
  oauthAppId?: string
  oauthAppName?: string
  oauthAppClientId?: string
  oauthAppClientName?: string
}

export const trackOAuthFlowOAuthEventOccurredPayload = ({
  screen,
  type,
  oauthAppId,
  oauthAppName,
  oauthAppClientId,
  oauthAppClientName,
}: TrackOAuthFlowOAuthEventOccurredType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'OAuth Flow',
    event_description: 'OAuth Event Occurred',
    platforms: 'web',
    object: 'Event',
    action: 'Occurred',
    object_name: 'oAuthFlow',
    screen,
    type,
    oauth_app_id: oauthAppId,
    oauth_app_name: oauthAppName,
    oauth_app_client_id: oauthAppClientId,
    oauth_app_client_name: oauthAppClientName,
  }

  if (!oauthAppId) {
    delete payload.oauth_app_id
  }

  if (!oauthAppName) {
    delete payload.oauth_app_name
  }

  if (!oauthAppClientId) {
    delete payload.oauth_app_client_id
  }

  if (!oauthAppClientName) {
    delete payload.oauth_app_client_name
  }

  return ['Event Occurred', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Screen Viewed
 */
export type TrackRegistrationTwoFactorAuthEnterCodeScreenViewedType = {
  tier: string
  origin: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeScreenViewedPayload = ({
  tier,
  origin,
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthEnterCode',
    screen: 'registrationTwoFactorAuthEnterCode',
    tier,
    origin,
    funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Confirm Button Tapped
 */
export type TrackRegistrationTwoFactorAuthEnterCodeConfirmButtonTappedType = {
  destination: string
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeConfirmButtonTappedPayload =
  ({
    destination,
    ctaTitle,
    funnel,
    funnelVersion,
  }: TrackRegistrationTwoFactorAuthEnterCodeConfirmButtonTappedType): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Two Factor Auth',
      event_description: 'Enter Code Confirm Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'registrationTwoFactorAuthEnterCode',
      screen: 'registrationTwoFactorAuthEnterCode',
      destination,
      cta_title: ctaTitle,
      funnel,
      funnel_version: funnelVersion,
    }

    if (!ctaTitle) {
      delete payload.cta_title
    }

    if (!funnelVersion) {
      delete payload.funnel_version
    }

    return ['Button Tapped', payload]
  }

/**
 * Registration Two Factor Auth
 * Enter Code Help Modal Viewed
 */
export type TrackRegistrationTwoFactorAuthEnterCodeHelpModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeHelpModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeHelpModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Help Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthHelp',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Resend Modal Viewed
 */
export type TrackRegistrationTwoFactorAuthResendModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthResendModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthResendModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Resend Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthResend',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Resend Button Tapped
 */
export type TrackRegistrationTwoFactorAuthEnterCodeResendButtonTappedType = {
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeResendButtonTappedPayload =
  ({
    ctaTitle,
    funnel,
    funnelVersion,
  }: TrackRegistrationTwoFactorAuthEnterCodeResendButtonTappedType): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Two Factor Auth',
      event_description: 'Enter Code Resend Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'registrationTwoFactorAuthResend',
      screen: 'registrationTwoFactorAuthEnterCode',
      cta_title: ctaTitle,
      funnel,
      funnel_version: funnelVersion,
    }

    if (!ctaTitle) {
      delete payload.cta_title
    }

    if (!funnelVersion) {
      delete payload.funnel_version
    }

    return ['Button Tapped', payload]
  }

/**
 * Registration Two Factor Auth
 * Enter Code Help Button Tapped
 */
export type TrackRegistrationTwoFactorAuthEnterCodeHelpButtonTappedType = {
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeHelpButtonTappedPayload = ({
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthHelp',
    screen: 'registrationTwoFactorAuthEnterCode',
    cta_title: ctaTitle,
    funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Back button tapped
 */
export type TrackRegistrationTwoFactorAuthBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeBack',
    style: 'icon',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Help Button Tapped
 */
export type TrackRegistrationTwoFactorAuthHelpButtonTappedType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpButtonTappedPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeHelp',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel,
    origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Help Modal Viewed
 */
export type TrackRegistrationTwoFactorAuthHelpModalViewedType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpModalViewedPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthEnterCodeHelpModal',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel,
    origin,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Help Modal Support
 */
export type TrackRegistrationTwoFactorAuthHelpModalSupportType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpModalSupportPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpModalSupportType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Modal Support',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeModalSupport',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel,
    origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Help Modal Try Again
 */
export type TrackRegistrationTwoFactorAuthHelpModalTryAgainType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpModalTryAgainPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpModalTryAgainType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Modal Try Again',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeModalTryAgain',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel,
    origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Sign In With Apple
 * Button tapped
 */
export enum SignInWithAppleButtonTappedCta_title {
  'SignUp' = 'signUp',
  'SignIn' = 'signIn',
  'ContinueWithApple' = 'continueWithApple',
}

export type TrackSignInWithAppleButtonTappedType = {
  screen: string
  ctaTitle: SignInWithAppleButtonTappedCta_title
}

export const trackSignInWithAppleButtonTappedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'signInWithAppleButton',
    screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Sign In With Apple
 * Button Viewed
 */
export enum SignInWithAppleButtonViewedCta_title {
  'SignUp' = 'signUp',
  'SignIn' = 'signIn',
  'ContinueWithApple' = 'continueWithApple',
}

export type TrackSignInWithAppleButtonViewedType = {
  screen: string
  ctaTitle: SignInWithAppleButtonViewedCta_title
}

export const trackSignInWithAppleButtonViewedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleButtonViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Button Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'signInWithAppleButtonContainer',
    screen,
    cta_title: ctaTitle,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Exists Modal Viewed
 */
export type TrackSignInWithAppleAccountExistsModalViewedType = {
  screen: string
}

export const trackSignInWithAppleAccountExistsModalViewedPayload = ({
  screen,
}: TrackSignInWithAppleAccountExistsModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Exists Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationAppleSSOExists',
    screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Exists Modal Dismissed
 */
export type TrackSignInWithAppleAccountExistsModalDismissedType = {
  screen: string
}

export const trackSignInWithAppleAccountExistsModalDismissedPayload = ({
  screen,
}: TrackSignInWithAppleAccountExistsModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Exists Modal Dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAppleSSOExistsDismissed',
    screen,
  }

  return ['Button Tapped', payload]
}

/**
 * Sign In With Apple
 * Account Suspended Modal Viewed
 */
export type TrackSignInWithAppleAccountSuspendedModalViewedType = {
  screen: string
}

export const trackSignInWithAppleAccountSuspendedModalViewedPayload = ({
  screen,
}: TrackSignInWithAppleAccountSuspendedModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Suspended Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationAppleSSOAccountSuspended',
    screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Suspended Modal Button Tapped
 */
export type TrackSignInWithAppleAccountSuspendedModalButtonTappedType = {
  screen: string
  ctaTitle: string
}

export const trackSignInWithAppleAccountSuspendedModalButtonTappedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleAccountSuspendedModalButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Suspended Modal Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAppleSSOAccountSuspendedCta',
    screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}
